import { useState } from 'react'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'
import { useMixpanel } from '@captaincause/lib/mixpanel'
import { Button } from 'components/Button'
import PrivateProjectPlaceholder from 'assets/private-project-placeholder.webp'
import { Modal } from './Modal'

export function PrivateProjectCard() {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation('projects.page')
  const { track } = useMixpanel()

  return (
    <article className="relative order-[1] mx-auto flex max-h-[400px] w-full max-w-[400px] flex-col rounded-xl transition-transform duration-300 ease-out hover:-translate-y-2 focus:-translate-y-2 focus:shadow-md sm:mx-[initial] md:max-w-none">
      <div className="relative mb-3 h-[336px] max-h-[336px] w-full overflow-hidden rounded-2xl">
        <Image
          src={PrivateProjectPlaceholder}
          alt="Add your private project"
          width={336}
          height={316}
          className="h-[inherit] w-full object-cover"
        />
      </div>

      <p className="mb-1 text-base font-semibold leading-6">
        {t('private-project.card.subtitle')}
      </p>
      <Button
        onClick={() => {
          setIsOpen(true)
          track('Project page - Click on private project card')
        }}
        variant="raw"
        breakout
        small
        className="w-full justify-between break-words text-left text-sm font-semibold leading-5 underline underline-offset-4"
      >
        {t('private-project.card.cta')}
      </Button>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen} />
    </article>
  )
}
